import React from 'react';
import PropTypes from 'prop-types';

const Period = ({ scoreboard }) => (
  <span className="inply-coupon-period">
    {scoreboard.dsc}
    {scoreboard.gDsc && ` ${scoreboard.gDsc}` }
  </span>
);

Period.propTypes = {
  scoreboard: PropTypes.isRequired,
};

export default Period;
